<ng-container *ngIf="isHeaderVisible">
  <div
    [ngClass]="{
      'header-opened': isHeaderOpen,
      'custom-theme-header': !!backgroundColor && !(isAtHomePage || isAtCreatorHomePage),
      'admin-access-header': (isAdminAccess && authService.userContext?.admin_name || authService.isWhiteLabelPreview),
      'transparent-header': scrSize <= screenSize.mobile ? (!isHeaderOpen && !isScrolling) : !isScrolling,
      'home-transition': isAtHomePage || isAtCreatorHomePage,
      'theme-header-border': isScrolling,
      'custom-text-logo-header': whiteLabelConfig?.is_text_logo || showWhiteLabelTextLogo,
      'at-home-page': isAtHomePage,
      'at-creator-page': isAtCreatorHomePage,
      'promotional-home': isPromotionalHome
    }"
    (scroll)="onWindowScroll()"
    (mouseleave)="onMouse()"
    [ngStyle]="{
      background: (isAtHomePage || isAtCreatorHomePage) && !isScrolling ? 'transparent' : '',
      borderBottom: (isAtHomePage || isAtCreatorHomePage) && !isScrolling ? 'none' : '',
      visibility: isWhiteLabelDataLoading ? 'hidden': 'visible',
      top: top ? top + 'px' : null
    }"
    class="header {{ lineRemoveClass }} {{ mobileHideClass }} {{ headerWithoutLogin }}"
  >
  <div *ngIf="isAdminAccess && authService.userContext?.admin_name" class="admin-name">
    <span>
      ACCESSING AS CRM ADMIN - {{ authService.userContext?.admin_name }}
    </span>
  </div>
  <div *ngIf="authService.isWhiteLabelPreview" class="admin-name">
    <span>
      WHITE LABEL SITE PREVIEW MODE
    </span>
  </div>
    <div
      *ngIf="(whitelabelUserData?.email | isMyProfile) && scrSize <= screenSize.mobile"
      class="whiteLabel-profile profileImage"
    >
      <div class="profileImage">
        <img
          *ngIf="whitelabelUserData?.profile_image_url"
          appDisableRightClick
          appMobileOptimization
          [originalUrl]="whitelabelUserData?.profile_image_url"
          [src]="whitelabelUserData?.profile_image_url"
          alt="Profile Image"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
    <div *ngIf="whitelabelUserData && backBtnDetails && scrSize <= screenSize.mobile">
      <a 
        [routerLink]="[backBtnDetails?.routerLink]"
        class="icon-back-whitelabel"
      >
        <em class="icon-arrow-back"></em>
      </a>
    </div>
    <span
      *ngIf="showMySiteLabel"
      class="logo white-label-mobile-logo align-self-center"
    >
      {{ headerLabels.MY_SITE }}
    </span>
    <a
      (click)="onRoute()"
      class="logo"
      *ngIf="!showMySiteLabel"
      [ngClass]="{ 'justify-content-start': !whiteLabelConfig?.logo_url, 'pro-page-logo-container': isAtProHomePage }"
    >
      <ng-container *ngIf="showWhiteLabelTextLogo; else headerImageLogo">
        <span
          class="white-label-text-logo"
          [style.font-family]="whiteLabelConfig?.user_font"
        >
          {{  whiteLabelConfig?.user_text  }}
        </span>
      </ng-container>
      <ng-template #headerImageLogo>
        <ng-container *ngIf="scrSize >= screenSize.desktop; else mobileLogo">
          <img
            [ngStyle]="scrSize < 450 && isLogedIn && { 'max-width': '120px' }"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="whiteLabelConfig?.logo_url || topFanLogoFallbackUrl"
            [src]="whiteLabelConfig?.logo_url || topFanLogoFallbackUrl"
            [alt]
            class="logo-default"
            [ngClass]="{'h-auto': !whiteLabelConfig?.logo_url, 'pro-page-logo': isAtProHomePage}"
            loading="eager"
            decoding="async"
          />
          <img
            [ngStyle]="scrSize < 450 && isLogedIn && { 'max-width': '120px' }"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="whiteLabelConfig?.logo_url || topFanLogoFallbackUrl"
            [src]="whiteLabelConfig?.logo_url || topFanLogoFallbackUrl"
            [alt]
            class="logo-theme"
            [ngClass]="{'pro-page-logo': isAtProHomePage}"
            loading="eager"
            decoding="async"
          />
          <img
            [ngStyle]="scrSize < 450 && isLogedIn && { 'max-width': '120px' }"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="whiteLabelConfig?.logo_url || topFanDarkLogoFallbackUrl"
            [src]="whiteLabelConfig?.logo_url || topFanDarkLogoFallbackUrl"
            [alt]
            class="black-logo-theme"
            [ngClass]="{'pro-page-logo': isAtProHomePage}"
            loading="eager"
            decoding="async"
          />
        </ng-container>
        <ng-template #mobileLogo>
          <img
            *ngIf="!isLogedIn || whiteLabelConfig?.logo_url || isArticlePostDetailPath"
            [ngStyle]="scrSize < screenSize.mobile && isLogedIn && !authService.isWhiteLabelWebsite() && { 'max-width': '120px' }"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="
              !isLogedIn || isArticlePostDetailPath
                ? whiteLabelConfig?.logo_url || topFanLogoFallbackUrl
                : whiteLabelConfig?.logo_url
            "
            [src]="
              !isLogedIn || isArticlePostDetailPath
                ? whiteLabelConfig?.logo_url || topFanLogoFallbackUrl
                : whiteLabelConfig?.logo_url
            "
            class="logo-default"
            [ngClass]="{'pro-page-logo': isAtProHomePage}"
            loading="eager"
            decoding="async"
          />
          <span
            *ngIf="isLogedIn && !whiteLabelConfig?.logo_url && !isArticlePostDetailPath && !whiteLabelConfig"
            class="topfan-mobile-icon"
          >
            <em class="icon-liteWithout-icon"></em>
          </span>
        </ng-template>
      </ng-template>
    </a>

    <a
      *ngIf="
        (authService.isLogin && permissionKeys.NEW_POST | hasPermission | async) &&
        ((authService.isLogin && !userProfileData?.is_white_label) ||
          (userProfileData?.is_white_label && userProfileData?.is_host_owner)) &&
          (userProfileData | showTabByApproval : SIDEBAR_TABS.NEW_POST)
      "
      [routerLink]="['/dashboard/newpost']"
      class="newpost-icon"
    >
      <em class="icon-res-newpost"></em>
    </a>
    <a
      *ngIf="
        (authService.isLogin && permissionKeys.NEW_POST | hasPermission | async) &&
        !userProfileData?.delegate_user?.type?.length &&
        ((authService.isLogin && !userProfileData?.is_white_label) ||
          (userProfileData?.is_white_label && userProfileData?.is_host_owner)) &&
          (userProfileData | showTabByApproval : SIDEBAR_TABS.LIVE_STREAM)
      "
      (click)="navigateToLiveStream()"
      class="newpost-icon"
    >
      <em class="icon-liteVideo-1"></em>
    </a>
    <div
      *ngIf="!whiteLabelConfig && (isAtHomePage || isAtCreatorHomePage || isPromotionalHome || isMarketingPageVisible)"
      class="action gap-3 ms-3 marketing-page-ctas marketing-page-ctas--desktop-only"
      [ngClass]="{ 'auth-marketing-page-ctas': authService?.isLogin }"
    >
      <div class="marketing-page-ctas__desktop">
        <div class="features-dropdown-wrapper">
          <a
            class="marketing-page-cta header-marketing-cta features-toggle-btn"
            (click)="toggleFeaturesDropdown($event)"
          >
            <span class="marketing-page-cta__text">{{ AUTH_CONSTANTS.Features }}</span>
            <svg
              class="features-chevron"
              [ngClass]="{ 'features-chevron--open': isFeaturesDropdownOpen }"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>
        <div class="features-dropdown-wrapper" *ngIf="PAGE_COMPARISONS?.length">
          <a
            class="marketing-page-cta header-marketing-cta features-toggle-btn"
            (click)="toggleCompareDropdown($event)"
          >
            <span class="marketing-page-cta__text">{{ AUTH_CONSTANTS.COMPARE }}</span>
            <svg
              class="features-chevron"
              [ngClass]="{ 'features-chevron--open': isCompareDropdownOpen }"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!whiteLabelConfig && (isAtHomePage || isAtCreatorHomePage || isPromotionalHome || isMarketingPageVisible)">
      <div class="features-dropdown-panel" *ngIf="isFeaturesDropdownOpen">
        <a
          *ngFor="let category of PAGE_FEATURES"
          class="features-dropdown-card"
          rel="noopener noreferrer"
          (click)="closeFeaturesDropdown(category)"
        >
          <div class="features-dropdown-card__img">
            <img
              appDisableRightClick
              appMobileOptimization
              [originalUrl]="category.imageUrl"
              [src]="category.imageUrl"
              [alt]="category.title"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="features-dropdown-card__title">
            {{ category.title }}
          </div>
          <div class="features-dropdown-card__link">
            {{ AUTH_CONSTANTS.EXPLORE_FEATURES }}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3.333 8h9.334M8.667 4l4 4-4 4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </a>
      </div>

      <div class="features-dropdown-panel comparison-dropdown-panel" *ngIf="isCompareDropdownOpen">
        <a
          *ngFor="let comparison of PAGE_COMPARISONS"
          class="features-dropdown-card comparison-dropdown-card"
          rel="noopener noreferrer"
          (click)="closeCompareDropdown(comparison)"
        >
          <div class="features-dropdown-card__img comparison-logo">
            <img
              appDisableRightClick
              appMobileOptimization
              [originalUrl]="comparison.competitor_logo"
              [src]="comparison.competitor_logo"
              [alt]="comparison.title"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="features-dropdown-card__link">
            {{ AUTH_CONSTANTS.EXPLORE_COMPARISON }}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3.333 8h9.334M8.667 4l4 4-4 4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </a>
      </div>
    </ng-container>
    <ng-container *ngIf="!whiteLabelConfig && (userProfileData | showTabByApproval : SIDEBAR_TABS.SEARCH)">
      <div
        *ngIf="
          !isAtAuthLoginPage &&
          !isAtAuthSignupPage &&
          !isAtCreatorHomePage &&
          !isAtAdvertisementHomePage &&
          !isMarketingPageVisible &&
          (!isAtHomePage || authService.isAuthenticatedAndConfirmed) &&
          (isLogin || isAtHomePage) &&
          (((isActionButton | async) && isSearch) || authService.isAuthenticatedAndConfirmed)
        "
        class="search-bar {{ searchClass }}"
        [ngClass]="{
          'custom-search-bar-theme': !!backgroundColor,
          'search-bar-open': isSearchBarOpen,
          'search-bar-home-transition': isAtHomePage,
          'd-none': !authService.isAuthenticatedAndConfirmed && scrSize < screenSize.mobile
        }"
      >
        <label for="search">
          <span
            (click)="onSearchIconClick()"
            class="search-icon"
            [ngClass]="{ whiteLabelSearchIcon: !!themeColor }"
          >
            <em
              id="addclass"
              [ngClass]="
                scrSize < screenSize.mobile
                  ? 'icon-litesearch-icon'
                  : 'icon-search'
              "
            ></em>
          </span>
        </label>
        <a
          (click)="isSearchBarOpen = !isSearchBarOpen; closeSearch()"
          class="icon-back"
        >
          <em class="icon-arrow-back"></em>
        </a>
        <app-search-bar-typeahead
          [userBlockList]="userBlockList"
          (listselected)="closeSearch()"
          [ngClass]="
            !!backgroundColor ? 'custom-search-bar-theme border-none' : null
          "
        ></app-search-bar-typeahead>
      </div>
    </ng-container>
    <div
      *ngIf="
        !isAtAuthSignupPage &&
        !isAtAuthVerifyByOtpPage &&
        !isAtCreatorHomePage &&
        !isAtProfileByUrl &&
        !isAtDashboardPage &&
        commonService.updateSignInVisibility() &&
        ((!authService.isLogin && !isLogin) || isLoginShow)
      "
      class="action"
      [ngClass]="{ 'd-lg-none': isWhitelabel, 'action-home-buttons': !isWhitelabel }"
    >
      <a
        *ngIf="!authService.isLogin && !isAtAuthLoginPage"
        [routerLink]="['/auth/login']"
        class="btn btn-primary"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        <span
          [ngStyle]="{color: themeColor ? '#ffffff' : null }" 
          class="d-none d-lg-block"
        >
          {{ isWhitelabel ? AUTH_CONSTANTS.GET_STARTED : AUTH_CONSTANTS.SIGN_IN_CAPS}}
        </span>
        <span
          [ngStyle]="{color: themeColor ? '#ffffff' : null }" 
          class="d-block d-lg-none"
        >
          {{ isWhitelabel ? AUTH_CONSTANTS.GET_STARTED : AUTH_CONSTANTS.SIGN_IN_CAPS}}
        </span>
      </a>
      <a
        *ngIf="
          !authService.isAuthenticated() &&
          !authService.isWhiteLabelWebsite() &&
          !isAtAuthLoginPage &&
          (isAtHomePage || (isLegalInformativePage))
        "
        (click)="navigateToCreators()"
        class="btn btn-primary become-a-creator-btn"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        <span class="d-block d-lg-none">{{ CREATORS_CONST.CREATORS }}</span>
        <span class="d-none d-lg-block">{{ CREATORS_CONST.CREATE_ON_TOPFANS }}</span>
      </a>
    </div>

    <div class="action" *ngIf="isAtAdvertisementHomePage">
      <a
        (click)="navigateToAdvertiseLogin()"
        class="btn btn-primary advertisement-get-started-btn"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        {{ADVERTISEMENT_CONST.ADVERTISEMENT_LOGIN}}
      </a>
      <a
        (click)="navigateToAdvertiseRegister()"
        class="btn btn-primary become-a-creator-btn advertisement-get-started-btn"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        {{ADVERTISEMENT_CONST.GET_STARTED}}
      </a>
    </div>

    <div class="action" *ngIf="isAtCreatorHomePage" 
      [ngClass]="{ 'action-home-buttons': !isWhitelabel }"
      >
      <a
        (click)="navigateToRequestADemo()"
        class="btn btn-primary"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        {{ CREATORS_CONST.REQUEST_DEMO }}
      </a>
      <a
        (click)="applyToJoin()"
        class="btn btn-primary become-a-creator-btn"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        {{ scrSize < screenSize.mobile ? CREATORS_CONST.APPLY : CREATORS_CONST.APPLY_NOW }}
      </a>
    </div>

    <div class="action marketing-page-ctas" [ngClass]="{ 'auth-marketing-page-ctas': authService?.isLogin }" *ngIf="isMarketingPageVisible">
      <a
        (click)="navigateToRequestADemo()"
        class="marketing-page-cta header-marketing-cta"
      >
        <span class="marketing-page-cta__text">{{ CREATORS_CONST.REQUEST_DEMO }}</span>
      </a>
      <a
        (click)="applyToJoin()"
        class="marketing-page-cta header-marketing-cta apply-now-btn"
        *ngIf="!isAtProHomePage"
      >
        <span class="marketing-page-cta__text">{{ scrSize < screenSize.mobile ? CREATORS_CONST.APPLY : CREATORS_CONST.APPLY_NOW }}</span>
      </a>
    </div>

    <div
      *ngIf="
        isWhitelabel &&
        !isSearch &&
        !isAtAuthLoginPage &&
        !isAtAuthSignupPage &&
        !isAtAuthVerifyByOtpPage
      "
      class="action d-lg-none"
    >
      <a
        *ngIf="!authService.isLogin"
        (click)="navigateToSignup()"
        class="btn btn-primary"
      >
        <span class="d-block">Get Started</span>
      </a>
    </div>
    <div class="d-none d-lg-block"
      [ngClass]="{'language-margin-right': authService.isLogin} "
      >
      <app-language-switcher></app-language-switcher>
    </div>
    <app-header-user-menu
      [themeColor]="themeColor"
      [backgroundColor]="backgroundColor"
      [isMarketingPageVisible]="isMarketingPageVisible"
      (menuOpenChange)="onHeaderOpen($event)"
    ></app-header-user-menu>

    <div
      class="header-mobile-language-switcher d-block d-lg-none"
      *ngIf="authService.isAuthenticatedAndConfirmed && !isSearchBarOpen"
      [ngClass]="{ 'creator-lang-margin' : userProfileData?.is_creator}"
    >
      <app-language-switcher></app-language-switcher>
    </div>

    <a *ngIf="authService.isAuthenticatedAndConfirmed && (userProfileData | showTabByApproval : SIDEBAR_TABS.MESSAGES)" [routerLink]="['/messages']" class="message-icon">
      <em class="icon-message"></em>
      <div *ngIf="messageCount" class="sidebar-nav-notification">
        {{ messageCount }}
      </div>
    </a>
    <div class="d-block d-lg-none me-3 order-9" *ngIf="!authService.isAuthenticatedAndConfirmed"
      [ngClass]="{ 'language-margin-right': !isWhitelabel && !authService.isLogin, 'ms-1': isWhitelabel && !authService.isLogin }">
      <app-language-switcher></app-language-switcher>
    </div>
    <div
      *ngIf="!whiteLabelConfig && (isAtHomePage || isAtCreatorHomePage || isPromotionalHome || isMarketingPageVisible)"
      class="marketing-kebab-wrapper marketing-page-ctas__mobile"
      (click)="toggleMarketingKebabMenu($event)"
    >
      <button
        type="button"
        class="marketing-kebab-btn"
        [attr.aria-label]="headerLabels.MORE_OPTIONS"
        [attr.aria-expanded]="isMarketingKebabMenuOpen"
      >
        <em class="icon-litemenu-icon"></em>
      </button>
      <div class="marketing-kebab-backdrop" *ngIf="isMarketingKebabMenuOpen" (click)="closeMarketingKebabMenu()"></div>
      <div class="marketing-kebab-menu" *ngIf="isMarketingKebabMenuOpen">
        <button
          type="button"
          class="marketing-kebab-menu__item"
          (click)="openFeaturesFromKebab($event)"
        >
          {{ AUTH_CONSTANTS.Features }}
        </button>
        <button
          *ngIf="PAGE_COMPARISONS?.length"
          type="button"
          class="marketing-kebab-menu__item"
          (click)="openCompareFromKebab($event)"
        >
          {{ AUTH_CONSTANTS.COMPARE }}
        </button>
      </div>
    </div>
  </div>
</ng-container>

<app-creator-requirements-modal #creatorsRequirementModal [isCreatorsHomePage]="true"></app-creator-requirements-modal>

<ng-template #bookDemoModal>
  <app-book-demo (closeModalClicked)="closeBookDemoModal()"></app-book-demo>
</ng-template>

<app-user-type-selection-modal #userTypeSelectionModal></app-user-type-selection-modal>
